import { CardMedia, Container, Paper } from '@mui/material';
import AuthForm, { STATE_LOGIN } from 'components/AuthForm';
import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import loginimg from '../assets/img/bg2.jpg';
import loginimg2 from '../assets/img/bg3.png';
import './AuthPage.css';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory } from 'react-router-dom';

const AuthPage = props => {
  const history = useHistory();
  const theme = useTheme();
  const matchesBigScreen = useMediaQuery(theme.breakpoints.up('md'));

  const handleAuthState = authState => {
    if (authState === STATE_LOGIN) {
      history.push('/login');
    } else {
      history.push('/signup');
    }
  };

  const handleLogoClick = () => {
    history.push('/');
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center gap-2 backgroundSelect"
      style={{
        minWidth: '100vw',
        minHeight: '100vh',
      }}
    >
      <Paper
        sx={{
          borderRadius: '25px',
          p: 2,
          minWidth: '70vw',
          boxShadow:
            'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
        }}
        elevation={10}
      >
        <Row>
          {matchesBigScreen && (
            <Col
              lg="6"
              className="d-flex flex-column justify-content-center align-items-center my-4"
            >
              <img
                alt="loginimg"
                src={loginimg}
                style={{
                  maxWidth: '500px',
                  objectFit: 'contain',
                  mixBlendMode: 'multiply',
                }}
              />
            </Col>
          )}

          <Col
            lg={matchesBigScreen ? '6' : '12'}
            className="d-flex flex-column justify-content-center align-items-center gap-2 my-4 "
          >
            {!matchesBigScreen && (
              <img
                alt="loginimg"
                src={loginimg2}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100px',
                  objectFit: 'contain',
                  mixBlendMode: 'multiply',
                }}
              />
            )}
            <AuthForm
              authState={props.authState}
              onChangeAuthState={handleAuthState}
              onLogoClick={handleLogoClick}
            />
          </Col>
        </Row>
      </Paper>
    </div>
  );
};

export default AuthPage;
